const development: boolean = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

const config = {
    host: development ? 'http://localhost:9999' : 'https://server.kmos-perm.com'
    //host: 'http://localhost:9999'
}

export default config;
